import { useContext, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "../components/BootstrapCompo";
import loginSuccess from "../context/actions/auth/loginSuccess";
import { GlobalContext } from "../context/Provider";
import henceforthApi from "../utils/henceforthApi";
import ShadowzLogo from "../assets/images/ShadowzLogo.svg";
export default ({ logOutNow }) => {
  const { authDispatch } = useContext(GlobalContext);

  const [state, setState] = useState({
    email: "",
    password: "",
    loading: false,
  });
  // const Navigate = useNavigate();

  const onSubmitForm = () => {
    console.log("onSubmitForm called");
    setState({
      ...state,
      loading: true,
    });
    const { email, password } = state;
    let items = {
      email: email,
      password: password,
      language: "ENGLISH",
    };
    console.log("items", items);
    henceforthApi.Auth.login(items)
      .then((res) => {
        console.log("res", res);
        // debugger;
        toast.success(res.message);
        loginSuccess(res)(authDispatch);
        // Navigate("users/1");
      })
      .catch((err) => {
        console.log("err message", err);
        let response = err?.response?.body;
        let error = response ? response.error_description : "Server error";
        toast.error(error);

        if (error.error) {
          if (String(error.error).includes("unauthorized")) {
            logOutNow();
          } else {
            setState({
              ...state,
              loading: false,
            });
          }
        } else {
          setState({
            ...state,
            loading: false,
          });
        }
      });
  };

  const handleInput = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    setState({
      ...state,
      [name]: value,
    });
  };

  const [firstEye, setFirstEye] = useState(true);

  return (
    <div style={{ backgroundColor: "#fff" }}>
      <div className="Login">
        <div class="middle-box text-center loginscreen animated fadeInDown d-flex justify-content-center align-items-center">
          <div>
            <div className="d-flex text-center">
              <img
                className="logo-img"
                height={50}
                src={ShadowzLogo}
              />
            </div>
            <h2 style={{ color: "#000" }}>Welcome to Shadowz</h2>
            <form
              class="m-t"
              role="form"
              onSubmit={(e) => {
                e.preventDefault();
                onSubmitForm();
              }}
            >
              <div class="form-group">
                <input
                  type="email"
                  className="form-control loginInput"
                  placeholder="Enter email address"
                  name="email"
                  value={state.email}
                  onChange={(e) => handleInput(e)}
                  required
                />
              </div>
              <div class="form-group">
                <input
                  type={firstEye ? "password" : "text"}
                  class="form-control"
                  placeholder="Enter password"
                  name="password"
                  data-ng-pattern="/^\S*$/"
                  value={state.password}
                  onChange={(e) => handleInput(e)}
                  required
                />
                <i
                  class={`fas  eye-btn ${firstEye ? `fa-eye-slash` : `fa-eye`}`}
                  onClick={() => setFirstEye(!firstEye)}
                  aria-hidden="true"
                  style={{ cursor: "pointer" }}
                ></i>
              </div>
              <button
                style={{
                  backgroundColor: "#000",
                }}
                type="submit"
                class="btn btn-primary block full-width m-b"
                disabled={state.loading || !state.email || !state.password}
              >
                {state.loading ? <Spinner /> : "Login"}
              </button>

              <Link to="/forgot-password" className="text-black">
                <small>Forgot password?</small>
              </Link>
              {/* <Link to="/reset-password" className="text-black">
                <small>Reset password?</small>
              </Link> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
